import produce from 'immer';
import { partition } from 'lodash';

import type { PageData } from '@swf/core/types/Poker';
import { ClubPlayerRole, ClubPlayerStatus } from '@swf/core/types/Poker';
import type { PlayerListElement } from '@swf/generated/types/api/v0/SwHomeGames';
import { countriesByCode } from '@swf/poker';

export const setClubMembers = (state: PageData, { response }: { response: PlayerListElement[] }) =>
  produce(state, (draft) => {
    const priority = [
      ClubPlayerRole.FOUNDER,
      ClubPlayerRole.ADMIN,
      ClubPlayerRole.MEMBER,
      ClubPlayerRole.SUSPENDED
    ];
    const parsedResponse = response.map((item) => ({
      ...item,
      location: countriesByCode[item.location || '']
    }));
    const [suspended, regular] = partition(
      parsedResponse,
      ({ membershipStatus }) => membershipStatus === ClubPlayerStatus.SUSPENDED
    );
    const regularSorted = regular.sort(
      (a, b) =>
        priority.indexOf(a.memberRole as ClubPlayerRole) -
          priority.indexOf(b.memberRole as ClubPlayerRole) ||
        +new Date(`${b.enrolled}`) - +new Date(`${a.enrolled}`)
    );
    const suspendedSorted = suspended.sort(
      (a, b) => +new Date(`${b.enrolled}`) - +new Date(`${a.enrolled}`)
    );

    draft.clubMembers = [...regularSorted, ...suspendedSorted];
  });
